module.exports = __webpack_public_path__ + "img/twn.8a194685.svg";